import { Navigate } from 'react-router-dom'
import { LoginForm } from './modules/authentication'
import { selectIsLoggedIn } from './modules/common'
import { useAppSelector } from './modules/core'

export const LoginLayout = () => {
  const isLoggedIn = useAppSelector(selectIsLoggedIn)

  // If already authenticated, redirect to home
  if (isLoggedIn) {
    return <Navigate to="/" replace />
  }

  return <LoginForm />
}
